// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-64de5cfd]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.header[data-v-64de5cfd] {\n  position: relative;\n}\n.header .back-btn[data-v-64de5cfd] {\n  position: absolute;\n  right: 20px;\n  top: 20px;\n}", ""]);
// Exports
module.exports = exports;
